import { localBlockComponents, localMicrositeComponents } from "../local/registry-block";

export const clayBuckBlockComponents = {
  ...localBlockComponents,
};

export const clayBuckMicrositeComponents = {
  ...localMicrositeComponents,
};
